import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear the token from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem("agent");

    // Redirect to the login page
    navigate('/login');
  }, [navigate]); // Empty array ensures this effect only runs once

  // Optionally, return null or a "logging out" message
  return null;
};

export default Logout;
